import { useState, useEffect } from "react";
import { motion, AnimatePresence } from "framer-motion";

const testimonials = [
  {
    quote:
      "FindNigeriaProperties is the platform I go to on almost a daily basis for 2nd home and vacation condo shopping, or to just look at dream homes in new areas.",
    name: "Alagba Sikiru",
    role: "Renter",
    image: "/assets/images/testimonial-2.jpeg",
  },
  {
    quote:
      "The property listings are comprehensive and the platform makes it easy to connect with sellers. Highly recommended for anyone looking to invest in Nigerian real estate.",
    name: "Chioma Okonkwo",
    role: "Investor",
    image: "/assets/images/testimonial-1.webp",
  },
  {
    quote:
      "As a realtor, this platform has helped me reach more potential buyers and close deals faster. The user interface is intuitive and professional.",
    name: "Mohammed Ibrahim",
    role: "Realtor",
    image: "/assets/images/testimonial-3.webp",
  },
];

export default function TestimonialSlideshow() {
  const [currentIndex, setCurrentIndex] = useState(0);
  const [progress, setProgress] = useState(0);
  const duration = 5000; // 5 seconds
  const updateInterval = 50; // Update progress every 50ms

  useEffect(() => {
    const progressInterval = setInterval(() => {
      setProgress((prev) => {
        if (prev >= 100) {
          setCurrentIndex((current) => (current + 1) % testimonials.length);
          return 0;
        }
        return prev + (updateInterval / duration) * 100;
      });
    }, updateInterval);

    return () => clearInterval(progressInterval);
  }, []);

  const selectTestimonial = (index: any) => {
    setCurrentIndex(index);
    setProgress(0);
  };

  return (
    <div className="flex flex-col items-center mt-16 lg:mt-36">
      <div className="flex flex-col items-center gap-4 lg:w-[471px]">
        <h1 className="text-main-900 text-center font-bold text-4xl">
          Testimonials
        </h1>
        <p className="text-gray-500 text-center font-normal text-base">
          See what our property managers, landlords, and tenants have to say
        </p>
      </div>

      <div className="flex flex-col items-center lg:w-[638px] min-h-[200px]">
        {/* Animated Testimonial */}
        <AnimatePresence mode="wait">
          <motion.div
            key={currentIndex}
            initial={{ opacity: 0, y: 20 }}
            animate={{ opacity: 1, y: 0 }}
            exit={{ opacity: 0, y: -20 }}
            transition={{ duration: 0.5 }}
            className="text-center mt-14"
          >
            <p className="text-main-900 font-medium text-lg">
              &quot;{testimonials[currentIndex].quote}&quot;
            </p>
            <p className="font-bold text-main-900 mt-6">
              {testimonials[currentIndex].name},{" "}
              <span className="font-normal text-gray-500">
                {testimonials[currentIndex].role}
              </span>
            </p>
          </motion.div>
        </AnimatePresence>
      </div>

      <div className="flex gap-4 mt-8">
        {testimonials.map((testimonial, index) => (
          <button
            key={index}
            onClick={() => selectTestimonial(index)}
            className="relative"
          >
            <svg
              width="63"
              height="64"
              viewBox="0 0 63 64"
              xmlns="http://www.w3.org/2000/svg"
            >
              <circle
                cx="31.5"
                cy="32"
                r="30"
                fill="none"
                stroke="#E8E6F9"
                strokeWidth="3"
              />
              {index === currentIndex && (
                <circle
                  cx="31.5"
                  cy="32"
                  r="30"
                  fill="none"
                  stroke="#2D96A7"
                  strokeWidth="3"
                  strokeDasharray="188.4"
                  strokeDashoffset={188.4 - (progress / 100) * 188.4}
                  strokeLinecap="round"
                  transform="rotate(-90 31.5 32)"
                  style={{
                    transition: "stroke-dashoffset 50ms linear",
                  }}
                />
              )}
              <foreignObject
                x="6.5"
                y="7.5"
                width="50"
                height="50"
                className="rounded-full overflow-hidden"
              >
                <motion.div
                  className="w-full h-full bg-center bg-cover rounded-full"
                  style={{
                    backgroundImage: `url(${testimonial.image})`,
                  }}
                  initial={{ opacity: 0 }}
                  animate={{ opacity: 1 }}
                  transition={{ duration: 0.5 }}
                ></motion.div>
              </foreignObject>
            </svg>
          </button>
        ))}
      </div>
    </div>
  );
}
